
import React, { useState } from 'react';
import AboutCard from '../components/AboutCard';
import { Button, } from "react-bootstrap"
import ReactCardFlip from 'react-card-flip';
import { ABOUT_CARD } from '../helpers/constants';

const About = () => {
    const [flipped, setFlipped] = useState(false)
    const flipCard = () => setFlipped(!flipped)
    return (
        <ReactCardFlip isFlipped={flipped} flipDirection="horizontal">
            {
                ABOUT_CARD.map((e, id) =>
                (
                    <AboutCard key={id} image={e.img} title={e.title} onClick={flipCard}>
                        <Button variant={e.color} href={e.link} >{e.button}</Button>
                    </AboutCard>
                ))
            }
        </ReactCardFlip>
    )
}



export default About;
